import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeader, SectionHeading } from '../../components/ui/Primitives';
import { getLmsPortalUrl } from '../../utils/portalConfig';

export default function Systems() {
  const navigate = useNavigate();
  const lmsUrl = getLmsPortalUrl();
  const steps = ['Campaign content', 'Public application', 'Lead review', 'Payment confirmation', 'Student access'];

  return (
    <div>
      <PageHeader eyebrow="Advanced" title="Systems" description="Reference the live acquisition, payment and learning-access flow." />
      <section>
        <SectionHeading title="Operational flow" description="Each stage hands a real user or record to the next system." />
        <ol className="systems-flow">
          {steps.map((step, index) => <li key={step}><span>{String(index + 1).padStart(2, '0')}</span><strong>{step}</strong></li>)}
        </ol>
        <div className="ui-form-actions">
          <button type="button" className="btn btn-primary" onClick={() => navigate('/register')}>Open public application</button>
          <button type="button" className="btn btn-outline" onClick={() => navigate('/lms')}>Open LMS entry</button>
        </div>
      </section>
      <section className="systems-section">
        <SectionHeading title="System destinations" />
        <div className="settings-list">
          <div className="settings-row"><span><strong>Public website</strong><span>Marketing, admissions and lead capture.</span></span><b>schoolofshem.com</b></div>
          <div className="settings-row"><span><strong>Learning portal</strong><span>Authenticated student, lecturer and admin work.</span></span><b>{lmsUrl}</b></div>
          <div className="settings-row"><span><strong>Content publishing</strong><span>Lecturer Content and Admin Website tools.</span></span><b>Portal</b></div>
          <div className="settings-row"><span><strong>Access activation</strong><span>Payment confirmation followed by role-based access.</span></span><b>Firebase</b></div>
        </div>
      </section>
    </div>
  );
}
